import { Container, Group, Stack, Text, Title } from '@mantine/core';

import { useRoleFlags } from '@/hooks/useRbac';
import { AiTreatmentPlanningSettings } from './AiTreatmentPlanningSettings';
import { TransferSummaryPromptSettings } from './TransferSummaryPromptSettings';

export function ClinicalSettingsPage(): JSX.Element {
  const { isAdmin } = useRoleFlags();

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        <div>
          <Group gap="sm" align="center" wrap="wrap" mb="xs">
            <Title order={2} mb={0}>
              Clinical settings
            </Title>
          </Group>
          <Text size="sm" c="dimmed">
            Configure clinical workflows and AI documentation preferences
          </Text>
        </div>

        <TransferSummaryPromptSettings />
        {isAdmin ? <AiTreatmentPlanningSettings /> : null}
      </Stack>
    </Container>
  );
}
